import React from 'react';
import { Row, Col } from 'react-bootstrap';

import Github from 'react-icons/lib/fa/github';
import Envelope from 'react-icons/lib/fa/envelope';
import LinkedIn from 'react-icons/lib/fa/linkedin';

import peter1 from './img/peter1.jpg';
import peter2 from './img/peter2.jpg';
import peter3 from './img/peter3.jpg';
import peter4 from './img/peter4.jpg';
import peter5 from './img/peter5.jpg';
import peter6 from './img/peter6.jpg';
import peter7 from './img/peter7.jpg';
import peter8 from './img/peter8.jpg';
import peter9 from './img/peter9.jpg';

import Signature from './Signature';

const cupcakes = [peter1,peter2, peter3, peter4, peter5, peter6, peter7, peter8, peter9];

const Landing = () => (
  <main>
    <section className="panels" id="home">
      <div className="jumbotron">
        <h2 className="section-heading">Hi! I'm Peter Zhu!</h2>
        <Quote />
      </div>
    </section>
    <section id="about">
      <Row>
        <Col xs={12} md={5} style={{ paddingTop: 50 }}>
          <img src={cupcakes[Math.floor(Math.random() * cupcakes.length)]} className="img-responsive img-circle" />
        </Col>
        <Col xs={12} md={6} style={{ paddingLeft: 50, paddingRight: 50 }}>
          <h2 className="section-heading">ABOUT ME</h2>
          <hr />
          <p style={{ fontSize: 14}}>
            This site randomizes many elements per load - refresh the page to see more! I did this because choosing things is hard.
          </p>
          <p>
             Hey there! I'm Peter Zhu, and I'm a senior studying EECS and Mechanical Engineering with a minor in Data Science
             at UC Berkeley. Go Bears!
          </p>
          <p>
             I am from San Diego and have moved to the Bay Area. My passion is in technology and writing the future through code. 
             I am {new Date(Date.now() - new Date(1999, 6, 24).getTime()).getUTCFullYear() - 1970} years old.
          </p>
          <p>
             In my free time, I like to watch and trade on the stock market, code up projects for fun, sleep in, go hiking, find good places to eat, and 
             relax with my dog. 
          </p>
        </Col>
        <Col xs={12} md={1} style={{ paddingTop: 50, fontSize: 40 }}>
          <a href="https://www.linkedin.com/in/peterzhu-meecs/" target="_blank" rel="nnoredirect no referrer"><LinkedIn /></a>
          <a href="https://github.com/peterzhucs" target="_blank" rel="noredirect no referrer"><Github /></a>
          <a href="mailto:peterzhu08@gmail.com" target="_blank" rel="nnoredirect no referrer"><Envelope /></a>
        </Col>
      </Row>
    </section>
    <Signature />
  </main>
);

const Quote = () => {
  const quotes = [
    {
      quote: 'The best thing about a boolean is even if you are wrong, you are only off by a bit.',
      author: 'A very funny CS student',
    },
    {
      quote: "It's not a bug - it's an undocumented feature ",
      author: 'every software engineer',
    },
    {
      quote: 'Some people eat to live, but I live to eat',
      author: 'me',
    },
  ];

  const quote = quotes[Math.floor(Math.random() * quotes.length)];
  return (
    <div className="quote">
      <p className="quote-content">
        &#34;{quote.quote}&#34;
      </p>
        <i>{quote.author}</i>
    </div>
  );
};

export default Landing;
